import { SearchX, Mail, Lightbulb } from "lucide-react";
import type { Escalation } from "@/api/types";

interface Props {
  escalation?: Escalation | null;
  question?: string;
}

// 근거 부족 시 억지 답변 대신 '관련 문서 없음'을 명확히 안내 + 에스컬레이션.
export default function NoAnswerCard({ escalation, question }: Props) {
  const msg = escalation?.message || "질문과 관련된 지식 저장소 문서를 찾지 못했습니다.";
  const hint = escalation?.hint;
  const contact = (escalation?.contact || "").trim();
  const subject = encodeURIComponent(`[ArkiveAI] 지식 등록 요청${question ? `: ${question.slice(0, 40)}` : ""}`);
  const body = encodeURIComponent(
    `아래 질문에 대한 문서가 지식 저장소에 없어 등록을 요청합니다.\n\n질문: ${question || ""}\n`,
  );

  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50/70 px-3.5 py-3 text-sm">
      <div className="flex items-start gap-2">
        <SearchX className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
        <div className="min-w-0 flex-1">
          <div className="font-semibold text-amber-900">관련 문서 없음</div>
          <p className="mt-0.5 text-amber-900/90">{msg}</p>
          {hint && (
            <p className="mt-1.5 flex items-start gap-1.5 text-xs text-amber-800/90">
              <Lightbulb className="mt-0.5 h-3.5 w-3.5 shrink-0" />
              <span>{hint}</span>
            </p>
          )}
          {contact && (
            <a
              href={`mailto:${contact}?subject=${subject}&body=${body}`}
              className="mt-2 inline-flex items-center gap-1.5 rounded-md bg-amber-600 px-2.5 py-1 text-xs font-semibold text-white hover:bg-amber-700"
            >
              <Mail className="h-3.5 w-3.5" /> 담당자에게 문서 등록 요청
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
